import { safeApiRequest } from './apiClient';
import { buildTechnicianUserPayload } from './technicianUserPayload';

export const fetchTpTechnicians = async (teknikServisId, { aktif = 'all' } = {}) => {
  if (!teknikServisId) throw new Error('Teknik servis ID gereklidir');
  const query = {};
  if (aktif === 'all') query.aktif = 'all';
  else if (aktif === false) query.aktif = 'false';
  return safeApiRequest(`/api/tech-services/${teknikServisId}/technicians`, {
    method: 'GET',
    query,
    skipCsrf: true,
  });
};

export const fetchTpTechnicianById = async (teknikServisId, teknisyenId) => {
  return safeApiRequest(`/api/tech-services/${teknikServisId}/technicians/${teknisyenId}`, {
    method: 'GET',
    skipCsrf: true,
  });
};

export const createTpTechnician = async (teknikServisId, payload) => {
  return safeApiRequest(`/api/tech-services/${teknikServisId}/technicians`, {
    method: 'POST',
    body: buildTechnicianUserPayload(payload, { requirePassword: true }),
  });
};

export const updateTpTechnician = async (teknikServisId, teknisyenId, payload) => {
  return safeApiRequest(`/api/tech-services/${teknikServisId}/technicians/${teknisyenId}`, {
    method: 'PUT',
    body: buildTechnicianUserPayload(payload, { requirePassword: false }),
  });
};
